import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';

import api from 'src/services/api';
import Mobile from 'src/services/Mobile';

import { logout } from 'src/store/modules/user';
import { removeAllPaths } from 'src/store/modules/paths';

import IconMenu from '../../components/IconMenu';

import { useStyles } from './styles';
import { useSelector } from 'react-redux';

const isMobile = Mobile.detectMobile();
function MainComponent({ children }) {
  const dispatch = useDispatch();
  const usuario = useSelector((state) => state.user);

  const history = useHistory();

  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(!isMobile);
  const [menusAbertos, setMenusAbertos] = useState([]);
  const [opcoes, setOpcoes] = useState([]);

  const handleLogout = () => {
    dispatch(logout());
    dispatch(removeAllPaths());

    localStorage.removeItem('toobiauth');
    localStorage.removeItem('usuario');

    history.push('/login');
  };

  const handleDrawerOpen = () => {
    setIsOpen(true);
  };

  const handleDrawerClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    api.get('/menuPai').then((res) => {
      if (res?.data?.length > 0) {
        let currentOpcoes = res.data;

        const menuDadosUsuarioIndex = currentOpcoes.findIndex(
          (opcao) => opcao?.nome === 'Sobre a conta'
        );

        // verifica se menu existe e coloca ele em primeiro lugar
        if (menuDadosUsuarioIndex >= 0) {
          const menuDadosUsuario = currentOpcoes[menuDadosUsuarioIndex];

          if (!usuario?.hasCompany && usuario?.perfil === 'COMUM') {
            const listaServicoIndex = currentOpcoes.findIndex(
              (opcao) => opcao?.nome === 'Serviços'
            );

            const baseCurrentOpcoes = currentOpcoes;
            currentOpcoes = [menuDadosUsuario];

            if (listaServicoIndex >= 0) {
              currentOpcoes.push(baseCurrentOpcoes[listaServicoIndex]);
            }
          }
        }

        const menusAbertos = currentOpcoes.map((o) => o.id);

        currentOpcoes.sort((prevOpcao, nextOpcao) => {
          if (prevOpcao?.order === null) {
            return 1;
          }

          return prevOpcao?.order < nextOpcao?.order ? -1 : 1;
        });

        setOpcoes(currentOpcoes);
        setMenusAbertos(menusAbertos);
      }
    });
  }, [usuario?.hasCompany, usuario?.perfil]);

  const handleClick = (opcao) => {
    if (isMobile) {
      setIsOpen(false);
    }
    history.push(opcao.rota);
  };

  const handleClickXmei = () => {
    if (localStorage.getItem('perfil') === 'ADMIN') {
      history.push('/dashboard');
    } else {
      history.push('/');
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        className={clsx(classes.appBar, {
          [classes.appBarShift]: isOpen,
        })}
      >
        <Toolbar>
          <Grid container>
            <Grid item xs={6} sm={6}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                className={clsx(classes.menuButton, isOpen && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <img
                src="/logo-white.png"
                alt="Xmei Logo"
                style={{
                  width: 72,
                  height: 45,
                  cursor: 'pointer',
                }}
                onClick={handleClickXmei}
              />
            </Grid>
            <Grid item xs={6} sm={6} className={classes.logout}>
              <div align="right">
                <Button color="inherit" onClick={handleLogout}>
                  <ExitToAppIcon />
                </Button>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor={isMobile ? 'top' : 'left'}
        open={isOpen}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {isOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <List component="nav" aria-labelledby="menu" className={classes.menu}>
          {opcoes.map((opcao) => {
            return (
              <Fragment key={opcao.id}>
                <ListItem
                  button
                  onClick={() => {
                    if (menusAbertos.includes(opcao.id)) {
                      const index = menusAbertos.indexOf(opcao.id);

                      const newMenusAbertos = [...menusAbertos];

                      newMenusAbertos.splice(index, 1);

                      setMenusAbertos(newMenusAbertos);
                    } else {
                      menusAbertos.push(opcao.id);

                      setMenusAbertos([...menusAbertos, opcao.id]);
                    }
                  }}
                >
                  <Divider />
                  <ListItemIcon>
                    <InboxIcon style={{}} />
                  </ListItemIcon>
                  <ListItemText
                    primary={opcao.nome}
                    style={{ color: '#000000', opacity: '0.6' }}
                  />
                  {menusAbertos.includes(opcao.id) ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </ListItem>
                {opcao.Menus.map((menu) => (
                  <Fragment key={menu.id}>
                    <Collapse
                      in={menusAbertos.includes(opcao.id)}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItem
                          button
                          className={classes.nested}
                          onClick={() => handleClick(menu)}
                        >
                          <ListItemIcon>{IconMenu(menu)}</ListItemIcon>
                          <ListItemText primary={menu.nome} />
                        </ListItem>
                      </List>
                    </Collapse>
                  </Fragment>
                ))}
              </Fragment>
            );
          })}
        </List>
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: isOpen,
        })}
      >
        <div className={classes.drawerHeader} />
        {children}
      </main>
    </div>
  );
}

MainComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainComponent;
